<template>
    <div>
        <div>
            <UpperBar v-on:add="addGroup" v-bind:newRecord="newGroup" v-bind:addButton="addButton" v-on:searched-data="setSearchBar"/>
            <div v-show="newGroup" class="template">
                <h5 ><span>Nazwa grupy: </span><b-input v-model="newName"></b-input></h5>
                <div class="buttons">
                    <b-button class="button" v-on:click="sendPost()">Zatwierdź</b-button>
                    <b-button class="button" v-on:click="cancelAdding()">Anuluj</b-button>
                </div>
            </div>
            <b-button v-on:click="showAll" class="showButton buttonShow">{{showGroupsButtonName}}</b-button>
            <div v-for="item in groups" :key="item._id">
                <div v-show="editedItem != item._id && item.name.toLowerCase().includes(searchBar.toLowerCase())" v-if="showAllGroups == true || searchBar" class="template">
                    <h5 ><span>Nazwa grupy: </span>{{item.name}}</h5>
                    <div class="groups">
                        <b-button class="buttonShow" v-on:click="showUsers(item.name)">Pokaż/Ukryj</b-button>
                        <div class="showGroups"><span>Członkowie grupy: </span>
                            <div v-for="user in users" :key="user._id">
                                <p v-if="user.groups.includes(item.name) && showAllUsers == item.name">{{user.lastName}} {{user.firstName}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="buttons" v-show="confirmation != item._id">
                        <b-button class="button" v-on:click="editGroup(item._id, item.name)">Edytuj</b-button>
                        <b-button class="button" v-on:click="delGroup(item._id)">Usuń</b-button>
                    </div>
                    <div v-if="confirmation === item._id" class="confirm">Czy napewno chcesz usunąć tą grupę ?
                        <b-button class="button" v-on:click="confirmDelGroup(item._id, item.name, item.author)">Tak</b-button>
                        <b-button class="button" v-on:click="cancelDelGroup()">Nie</b-button>
                    </div>
                </div>
                <div v-if="editedItem == item._id" class="template">
                    <h5 ><span>Nazwa grupy: </span><b-input v-model="nameToEdit"></b-input></h5>
                    <div class="upperPanel">
                        <b-button class="showButton" v-on:click="allUsers = !allUsers">Pokaż wszystkich pracowników</b-button>
                        <div class="searchInput">
                            <b-input-group>
                                <b-input-group-prepend is-text>
                                    <b-icon icon="search" variant="primary"></b-icon>
                                </b-input-group-prepend>
                                <b-input type="search" :placeholder="'min. 3 znaki'" name="searchBar" v-model="searchUser">
                                </b-input>
                            </b-input-group>
                        </div>
                    </div>
                    <div class="showGroups"><span>Członkowie grupy: </span>
                        <button v-for="user in users" :key="user._id" 
                        v-show="(user.lastName.toLowerCase().includes(searchUser.toLowerCase())
                        || user.firstName.toLowerCase().includes(searchUser.toLowerCase())) && (searchUser.length > 2 || allUsers)"
                        v-bind:class="[user.groups.includes(item.name) ? correct : negative, 'groupButton']"
                        v-on:click="toggleUser(user._id, item.name, user)">
                            {{user.lastName}} {{user.firstName}}
                        </button>
                    </div>
                    <div class="buttons">
                        <b-button class="button" v-on:click="applyChanges(item._id, nameToEdit, item.name, item.author)">Zatwierdź</b-button>
                        <b-button class="button" v-on:click="cancelChanges(item.name)">Anuluj</b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import {path} from '../../../config';
import UpperBar from '../ViewElements/UpperBar';
export default {
    name: 'TargetGroupCMS',
    components: {
        UpperBar,
    },
    methods: {
        editGroup: async function(id, name){
            this.editedItem = id;
            this.nameToEdit = name;
            this.usersBackup = [];
            this.searchUser = '';
            this.allUsers = false;
            for(let user of this.users){
                if(user.groups.includes(name) && !this.usersBackup.includes(user)){
                    await this.usersBackup.push(user)
                }
            }
        },
        delGroup: async function(id){
            this.confirmation = id;
            this.editedItem = '';
        },
        confirmDelGroup: async function(id, name, author){
            this.deleteUser(id, name, author);
            this.deleteGroup(id);
        },
        deleteUser: async function (id, name, author){
            for(let item of this.users){
                if(item.groups.includes(name)){
                    item.groups = item.groups.filter(x => x !== name)
                    let payload = {
                        lastName: item.lastName,
                        firstName: item.firstName,
                        phoneNumber: item.phoneNumber,
                        mailAddress: item.mailAddress,
                        groups: item.groups,
                        author: author
                    }
                    await axios
                    .put(`${path}users/${item._id}`, payload)
                    .then(r => console.log(r.status))
                    .catch(e => console.log(e));
                }
            }
        },
        deleteGroup: async function(id){
            await axios
                .delete(`${path}groups/${id}`)
                .then(r => console.log(r.status))
                .catch(e => console.log(e));
            console.log('group deleted')
            this.$emit('shutGroups', 'Usunięto grupę docelową');
        },
        cancelChanges: function(name){
            this.editedItem = '';
            for(let user of this.users){
                if(user.groups.includes(name) && !this.usersBackup.includes(user)){
                    user.groups = user.groups.filter(x => x !== name);
                }   else if(!user.groups.includes(name) && this.usersBackup.includes(user)){
                    user.groups.push(name);
                }
            }
        },
        applyChanges: async function(id, name, oldName, author){
            this.editedItem = '';
            this.searchUser = '';
            this.allUsers = false;
            let updatedAuthor = author
            const payload = {
                name: name,
                author: updatedAuthor,
            }
            await this.updateUsers(name, oldName)
            await this.updateGroups(id, payload)
        },
        updateUsers: async function(name, oldName){
            for(let item of this.changedUsers){
               if(item.groups.includes(oldName)){
                    item.groups[item.groups.indexOf(oldName)] = name;
                    let payload = {
                        lastName: item.lastName,
                        firstName: item.firstName,
                        phoneNumber: item.phoneNumber,
                        mailAddress: item.mailAddress,
                        groups: item.groups,
                        author: item.author
                    }
                    await axios
                    .put(`${path}users/${item._id}`, payload)
                    .then(r => console.log(r.status))
                    .catch(e => console.log(e));
                 }   else {
                    let payload = {
                        lastName: item.lastName,
                        firstName: item.firstName,
                        phoneNumber: item.phoneNumber,
                        mailAddress: item.mailAddress,
                        groups: item.groups,
                        author: item.author
                    }
                    await axios
                    .put(`${path}users/${item._id}`, payload)
                    .then(r => console.log(r.status))
                    .catch(e => console.log(e));
                 }
            }
            
        },
        updateGroups: async function(id, payload){
            await axios
                .put(`${path}groups/${id}`, payload)
                .then(r => console.log(r.status))
                .catch(e => console.log(e));
            this.changeGroups(id);
        },
        changeGroups: function(id){
            for(let item of this.groups){
                if(item._id === id){
                    item.name = this.nameToEdit;
                }
            }
        },
        addGroup: function(){
            this.newGroup = true;
        },
        cancelAdding: function(){
            this.newGroup = false;
            this.newName = '';
        },
        cancelDelGroup: function() {
            this.confirmation = '';
        },
        sendPost: async function(){
            const payload = {
                name: this.newName,
                author: this.userData.name
            } 
            await axios
                .post(`${path}groups`, payload)
                .then(r => console.log(r.status))
                .catch(e => console.log(e));
            this.newGroup = false;
            console.log('Group sent')
            this.$emit('shutGroups', 'Dodano nową grupę docelową');
        },
        toggleUser: async function(id, name, user){
            if(!this.changedUsers.includes(user)){
                this.changedUsers.push(user)
            } else {
                for(let item of this.changedUsers){
                    if(item._id == id){
                        let index = this.changedUsers.indexOf(item)
                        this.changedUsers.splice(index, 1)
                    }
                }
            }
            for(let item of this.users){
                if(item._id === id && !item.groups.includes(name)){
                    item.groups.push(name);
                }   else if(item._id === id && item.groups.includes(name)){
                    item.groups = item.groups.filter(x => x !== name)
                }
            }
        },
        setSearchBar: function(searchData){
            this.searchBar = searchData;
        },
        showUsers: function(name){
            if(!this.showAllUsers){
                this.showAllUsers = name;
            } else if(this.showAllUsers == name){
                this.showAllUsers = '';
            } else{
                this.showAllUsers = name
            }
        },
        showAll: function(){
            this.showAllGroups = !this.showAllGroups;
            if(this.showGroupsButtonName === 'Pokaż wszystkie grupy'){
                this.showGroupsButtonName = 'Ukryj wszystkie grupy';
            } else {
                this.showGroupsButtonName = 'Pokaż wszystkie grupy';
            }
        }
    },
    props: ['dbGroups', 'dbUsers', 'userData'],
    data: function(){
        return{
            users: this.dbUsers,
            changedUsers: [],
            usersBackup: [],
            groups: this.dbGroups,
            editedItem: '',
            nameToEdit: '',
            newGroup: false,
            newName: '',
            confirmation: '',
            correct: 'correct',
            negative: 'negative',
            searchBar: '',
            addButton: 'Dodaj Grupę',
            showAllUsers: '',
            showGroupsButtonName: 'Pokaż wszystkie grupy',
            showAllGroups: false,
            searchUser: '',
            allUsers: false,
        }
    }
}
</script>
<style lang="scss" scoped>
    .template {
        border-top: solid;
        border-bottom: solid;
        border-color: blue;
        border-width: 2px;
        border-radius: 10px;
        margin-bottom: 5px;
        text-align: left;
        padding-left: 10px;
        .buttons {
            display: flex;
            justify-content: space-evenly;
            margin-bottom: 5px;
        }
        span {
            font-weight: bold;
        }
        .showGroups {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            margin-bottom: 5px;
            overflow: auto;
            max-height: 300px;
            p{
                margin: 5px 5px;
                padding: 0 5px;
                border: solid;
                border-width: 1px;
            }
            button {
                margin: 5px;
                border: none;
                font-family: 'Source Code Pro', monospace;
            }
        }
    }
    .confirm{
        background-color: red;
        margin: 10px 0;
        border-radius: 10px;
        color: white;
        padding: 0 5px;
        .button {
            margin: 5px;
        }
    }
    .correct {
        background-color: green;
    }
    .negative {
        background-color: red;
    }
    .groupButton {
        color: white;
    }
    .showButton {
        margin: 0 0 10px 0;
    }
    .buttonShow {
        background-color: green;
        border: none;
        margin: 10px auto;
        &:hover{
            background-color: rgb(101, 168, 0);
        }
        &:focus{
            background-color: green;
            border: none;
            box-shadow: none;
        }
    }
    .upperPanel {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: center;
    width: 90%;
    margin: 0 auto;
    .showButton {
    background-color: green;
    margin: 10px;
    }
    .icon {
        background-color: blue;
    }
}
</style>